<template>
  <div class="c-tabs">
    <a
      href="#"
      class="c-tab"
      :class="{ 'c-tab--active': item.isSelected }"
      v-for="item in items"
      :key="item.label"
    >
      {{ item.label }}
    </a>
  </div>
</template>

<script>
// @group Base Components
export default {
  name: 'OTabs',
  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss">
.c-tabs {
  background: #fff;
  display: flex;
  flex: none;
}

.c-tab {
  box-shadow: inset 0 -0.1rem 0 rgba(#000, 0.1);
  color: $gray-500;
  flex: 1;
  font-weight: 600;
  padding: 1.6rem;
  text-align: center;
}

.c-tab--active {
  box-shadow: inset 0 -0.2rem $primary-color;
  box-shadow: inset 0 -0.2rem var(--primary-color);
  color: $text-color;
  color: var(--text-color);
}
</style>
